import { Controller } from "@hotwired/stimulus"

// Puts the Crepe editor's markdown into the field the form posts. The editor
// holds its text in ProseMirror state rather than in an input, so the field is
// empty until something asks the controller for it.
//
// The listener sits on the form, so it runs in the event's target phase —
// before Turbo, which handles submit while it bubbles at the document.
export default class extends Controller {
	static targets = ["field"]

	sync() {
		const wrapper = this.element.querySelector('[data-controller~="crepe-editor"]')
		if (!wrapper) return
		const editor = this.application.getControllerForElementAndIdentifier(wrapper, "crepe-editor")
		if (editor) this.fieldTarget.value = editor.getMarkdown()
	}
}
